import { Injectable } from '@angular/core';
import { Category } from '../../interface/category/category';
import { HttpService } from '../http/http.service';
import { firstValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CategoryService {

  constructor(private _categoryService: HttpService) { }

  public getAll(): Promise<Category[]> {
    return firstValueFrom(this._categoryService.get('/Categories'));
  }
  public get(id: number): Promise<Category> {
    return firstValueFrom(this._categoryService.get('/Categories/' + id));
  }
  public add(data: Category): Promise<Category> {
    return firstValueFrom(this._categoryService.post('/Categories', data));
  }
  public update(id: number, data: Category): Promise<Category> {
    return firstValueFrom(this._categoryService.patch('/Categories/', id, data));
  }
  public async delete(id: number): Promise<Category> {
    return firstValueFrom(this._categoryService.delete('/Categories/', id));
  }

}
